/**
 * מדינה ראשונה ממסלול (חלק לפני " — " בתווית העיר הראשונה).
 * @param {Record<string, unknown>|null|undefined} vm
 * @returns {{ key: string, label: string } | null}
 */
export function extractOrgTourCountryChip(vm) {
  if (!vm || typeof vm !== "object") return null;
  const cities = vm.routeCities;
  if (!Array.isArray(cities) || cities.length === 0) return null;
  const label = String(cities[0]?.label ?? "").trim();
  if (!label) return null;
  const country = label.split(/\s*—\s*/)[0]?.trim();
  if (!country) return null;
  const key = country.toLowerCase();
  if (!key) return null;
  return { key, label: country };
}

/**
 * @param {Array<Record<string, unknown>>} vms
 * @returns {{ chips: Array<{ key: string, label: string, count: number }>, detectedKeys: string[] }}
 */
export function buildOrgTourCountryChips(vms) {
  const rows = Array.isArray(vms) ? vms : [];
  const counts = new Map();
  const labels = new Map();
  for (const vm of rows) {
    const ex = extractOrgTourCountryChip(vm);
    if (!ex?.key) continue;
    counts.set(ex.key, (counts.get(ex.key) || 0) + 1);
    if (!labels.has(ex.key)) labels.set(ex.key, ex.label);
  }
  const detectedKeys = [...counts.keys()].sort((a, b) =>
    (labels.get(a) || "").localeCompare(labels.get(b) || "", "he")
  );
  const chips = detectedKeys.map((key) => ({
    key,
    label: labels.get(key) || key,
    count: counts.get(key) || 0,
  }));

  return { chips, detectedKeys };
}
